import React, { useEffect, useMemo, useState } from "react";

import ChangePasswordBody from "./ChangePasswordBody";

import { Post } from "utils/request";
import { Link, useHistory, useLocation, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Header } from "modules/Header";
import "./index.css";
import { useMainPages } from "modules/Header/data";
import { Box, useTheme } from "@mui/material";
import WhatsappButton from "components/WhatsappButton";
import { Show } from "actions/SnackbarActions";
import { API_URL } from "variables";

const Validator = (props) => {
  
  const user = useSelector((store) => store.AppReducer.user);
  const token = useSelector((store) => store.AppReducer.token);

  const [loading, SetLoading] = useState(false);
  const { session_id } = useParams();

  const [errorsList, SetErrors] = useState([]);
  const [link, SetLink] = useState(null);

  const history = useHistory();

  const dispatch = useDispatch();
  const location = useLocation();
  const theme = useTheme();

  const loginTheme = useSelector(
    (store) => store.StylesReducer.pagesThemes?.login
  );
  const pages = useMainPages();

  const Login = async (data) => {
    if (!data.password || data.password === ""){
      return alert("Insira um código");
    }

   

    let form = new FormData();

      form.append("certificate_id", data.password);

      SetLoading(true);
      let response = await Post("certificate/download", form);
      console.log(response)
      if (response?.httpCode==200) {
        SetLoading(false)
        console.log('entrou')
        document.getElementById('link_open').href=`${API_URL}certificate/generate?course_id=${response.course_id}&user_id=${response.user_id}`
        document.getElementById('link_open').click()
      } else  {
        SetErrors(['Certificado não encontrado']);

        SetLoading(false);

        return;
      }
      
    
  };

  useEffect(() => {
    if (!user || user.first_access == false) {
      // history.replace("/");
    }
  }, []);

  useEffect(() => {
    console.log("login theme", loginTheme?.palette?.backgroundImage);
  }, [loginTheme]);

  return (
    <>
      <a hidden target="_blank" id='link_open'></a>
      <Header pages={pages} />
      <ChangePasswordBody
        onSubmit={(data) => {
          if (data === null || data === undefined) return;
          Login(data);
        }}
        errors={errorsList}
        link={link}
        loading={loading}
      />
      <WhatsappButton />
    </>
  );
};

export default Validator;
